import {AxiosPromise} from 'axios';
import buildURL from 'axios/lib/helpers/buildURL';

import {BusinessInfo, PersonalInfo} from 'models/Profile';
import MercuryAPI from 'services/api/mercury';

export enum INFO_TYPE {
  COMPANION_NUMBER_OR_PAYMENT_INFO = '2',
  PROFILE_INFO = '7',
}
export interface EditGuestProfileResponse {
  guestpreferenceupdate?: {
    resultstatus?: string;
  };
  resultstatus?: string;
  resultmessage?: string;
}

export interface EditGuestProfileRequestDataBase {
  responseformat: 'json' | 'xml';
  primaryaccttoken: string;
  primaryacctid: string;
  infotype: string;
  mfatoken: string;
}

export interface EditCompanionNumberRequestData
  extends EditGuestProfileRequestDataBase {
  companion: string;
}

export interface EditPersonalInfoRequestData
  extends EditGuestProfileRequestDataBase,
    PersonalInfo {}

export interface EditBusinessInfoRequestData
  extends EditGuestProfileRequestDataBase,
    BusinessInfo {}

export interface EditPaymentInfoRequestData
  extends EditGuestProfileRequestDataBase {
  globaltoken?: string;
  cctype?: string;
  ccexp?: string;
}

export type EditGuestProfileRequestData =
  | EditCompanionNumberRequestData
  | EditPersonalInfoRequestData
  | EditBusinessInfoRequestData
  | EditPaymentInfoRequestData;

export const editGuestProfile = (
  data: EditGuestProfileRequestData
): AxiosPromise<EditGuestProfileResponse> => {
  return MercuryAPI.runMercuryAPIRequest({
    url: 'EditGuestProfile',
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    data,
  });
};
